import styled from 'styled-components';

export const MenuButton = styled.div`
    position: fixed;
    left: 2.2vw;
    top: 2.2vw;
    width: 2vw;
    height: 2vw;
    @media only screen and (max-width: 900px) {
        width: 6vw;
        height: 6vw;
    }
    &.mobileVersion {
        width: 6vw;
        height: 6vw;
    }
    z-index: 100;
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.5s;
    &:hover {
        opacity: 1;
    }
`;

export const Menu = styled.div`
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    a {
        color: black;
        text-decoration: none;
        transition: all 0.5s;
        font-size: 7.8vw;
        @media only screen and (max-width: 900px) {
            font-size: 18vw;
        }
        font-family: LSCCondensed;
        font-style: italic;
        line-height: 1em;
        &:hover {
            color: red;
        }
    }
    &.mobileVersion {
        a {
            font-size: 18vw;
        }
    }
    > div {
        width: auto;
        margin-left: -1.8vw;
    }
`;